/**
 * api/deliveryCheck.js — Conferência de Entrega (Fase 6 · Bloco 5).
 * GET  /projects/{id}/delivery-check           → matriz de rastreabilidade
 * POST /projects/{id}/delivery-check/generate  → gera via QA (Claude)
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client';
import { isExecutionActive } from '../screens/remediationPanelState';

export function useDeliveryCheck(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: ['delivery-check', projectId],
    queryFn:  () => api.get(`/projects/${projectId}/delivery-check`),
    enabled:  Boolean(projectId),
  });
}

/**
 * useLatestExecution — resolve a última execução do projeto (executionId + status).
 * O Gate Final usa isso para buscar o PR e os compliance checks (que são por execução).
 */
export function useLatestExecution(projectId) {
  const api = useApi();
  return useQuery({
    queryKey: ['latest-execution', projectId],
    queryFn:  () => api.get(`/projects/${projectId}/latest-execution`),
    enabled:  Boolean(projectId),
    // Enquanto a execução roda, reconsulta p/ a tela saber quando liberar (ex.: Remediar).
    refetchInterval: (query) => (isExecutionActive(query.state.data?.status) ? 15_000 : false),
  });
}

export function useGenerateDeliveryCheck(projectId) {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationKey: ['ai'],
    meta: { aiLabel: 'A IA está conferindo a entrega…', aiSublabel: 'Checando o resultado contra o escopo, os critérios de aceite e os padrões de qualidade.' },
    mutationFn: () => api.post(`/projects/${projectId}/delivery-check/generate`, {}),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ['delivery-check', projectId] }),
  });
}
